const Cookies = require('cookies-js');

const parseCookieToJson = (encodedCookieString) => encodedCookieString && JSON.parse(atob(encodedCookieString));
const encodeJsonToCookie = (cookieData) => cookieData.length && btoa(JSON.stringify(cookieData));

const getPopupMessagesData = () => {
  const popupMessageDataString = Cookies.get('popupMessages');
  if (popupMessageDataString && popupMessageDataString !== '') {
    return parseCookieToJson(popupMessageDataString);
  }
  return [];
};

const getPopupMessage = () => {
  const activeMessages = getPopupMessagesData()
    .filter((messageItem) => messageItem && messageItem.state === 0);
  return activeMessages.length > 0 ? activeMessages[0] : false;
};

export const getActiveMessage = () => {
  const message = getPopupMessage();
  return message !== undefined ? message : false;
};

export const disableMessageById = (messageId) => {
  const allMessages = getPopupMessagesData();
  const updatedMessages =
    [...allMessages].map((messageItem) => (messageId === messageItem.id ? { ...messageItem, state: 1 } : messageItem));
  if (updatedMessages && updatedMessages.length > 0) {
    Cookies.set('popupMessages', encodeJsonToCookie(updatedMessages));
  }
};
